'use client';

import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { FeedbackHeaderButton } from '@/features/support/ui/FeedbackHeaderButton';

/**
 * Leading page heading with a trailing action cluster, for the pages whose
 * header IS their in-content `<h1>` (account hub, help center) rather than a
 * sticky nav bar. Keeps the Feedback action on the same baseline as the title,
 * matching the sticky-header pages (`ProjectSubpageLayout`, history, account
 * subpages) instead of floating it somewhere else.
 */
export function PageTitleRow({
  title,
  actions,
  className,
}: {
  title: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 px-1 pb-4',
        className
      )}
    >
      <h1 className="text-page-title text-foreground truncate">{title}</h1>
      {/* Feedback leads the cluster — see `ProjectSubpageLayout`. */}
      <div className="flex items-center gap-2 shrink-0">
        <FeedbackHeaderButton />
        {actions}
      </div>
    </div>
  );
}
